module.exports = __webpack_public_path__ + "img/applyOverseaen1.e4abb90a.png";